<template>
  <div>
    <v-btn
      :color="params.data.hasMIAOrder ? 'secondary' : 'primary'"
      small
      @click="setHardwareItem()"
      >Hardware</v-btn
    >
    <v-btn color="primary" small @click="setOrderItem()">Order</v-btn>
    <v-btn
      color="primary"
      v-if="$ld.flags && $ld.flags.vonexAdminUbServices"
      small
      @click="getServices"
      >Import Services</v-btn
    >
  </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  data: () => ({
    orderItem: null,
  }),
  methods: {
    setHardwareItem() {
      let hardware = this.params.data;
      hardware.type = "hardware";
      this.params.clicked(hardware);
    },
    setOrderItem() {
      let order = this.params.data;
      order.type = "order";
      this.params.clicked(order);
    },
    getServices() {
      let order = this.params.data;
      order.type = "services";
      this.params.clicked(order);
    },
  },
});
</script>
